import React, {Component, useEffect, useState } from "react";
import '../../../src/index.css'
import { BrowserRouter , Link, NavLink, useNavigate} from 'react-router-dom';

import Carousel from 'react-bootstrap/Carousel';

import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';

//import "react-responsive-carousel/lib/styles/carousel.min.css";
//import { Carousel } from "react-responsive-carousel";
import {Helmet} from "react-helmet";
import Header from "../../layout/Header";
import Footer from "../../layout/Footer";




const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}))



function KamolacCoatingHome() {


 useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
   

  return (
   

    <>
    
   <Helmet>
   <title>Paints for Home| Wall & Roof Paints - Kamdhenu Paints</title>
   <meta name="description" content="Kamdhenu paints is the best home painting, wall and roof paints manufacturer in India. Explore a wide range of Home wall paint colors and waterproofing solutions." />
   </Helmet>

    <div><Header /></div>
      {/* <div className="homecarousal">
       
        <Carousel>
      <Carousel.Item>
   
        <img
          className="d-block w-100"
          src={process.env.PUBLIC_URL + '/images/1.jpg'}
          alt="Kamdhenu Paints"
        />
      </Carousel.Item>
      <Carousel.Item>
        <img
          className="d-block w-100"
          src={process.env.PUBLIC_URL + '/images/2.jpg'}
          alt="Kamdhenu Paints"
        />

      </Carousel.Item>
      <Carousel.Item>
        <img
          className="d-block w-100"
          src={process.env.PUBLIC_URL + '/images/3.jpg'}
          alt="Kamdhenu Paints"
        />

      </Carousel.Item>
      <Carousel.Item>
        <img
          className="d-block w-100"
          src={process.env.PUBLIC_URL + '/images/4.jpg'}
          alt="Kamdhenu Paints"
        />

      </Carousel.Item>
    </Carousel>
      
      </div> */}
     
<section class="kamolac-hero-elegant">

  <div class="hero-wrapper">

    <div class="hero-text">

     
      <h1>
       Where Innovation Meets Elegance: Welcome to <span>Kamolac</span>
      </h1>

      <p class="desc">
       Experience the pinnacle of surface protection and aesthetic brilliance. Kamolac, the premium coating range by Kamdhenu Paints, brings you world-class finishes engineered to transform wood, metal, and glass into masterpieces.

      </p>

      <div class="line"></div>

      <h3 class="sub">The Future of Finishing </h3>
      <h2 class="headline">Don’t Just Paint.</h2>
      <h3 class="sub">Protect & Perfect.</h3>

      <p class="sub-text">
      From the mirror-shine of High-Gloss PU to the sustainable clarity of Water-Based coatings—discover the professional’s choice for luxury finishes. 
      </p>

      

    </div>

    <div class="hero-visual">  <img src={process.env.PUBLIC_URL + '/images/products/new/4.jpeg'} alt="Kamdhenupaints" /> </div>

  </div>

</section>

<section class="kamolac-section">
  <div class="kamolac-container">

    <h2 class="kamolac-title">The Kamolac Spectrum</h2>
    <p class="kamolac-subtitle">Our Signature Ranges</p>

    <div class="kamolac-grid">

   
      <div class="kamolac-card">
         <img src={process.env.PUBLIC_URL + '/images/products/new/6.png'} alt="Kamdhenupaints" />
        <div class="kamolac-content">
          <h3>PU Wood Finishes</h3>
          <p class="kamolac-tag">The Gold Standard</p>
          <p class="kamolac-desc">
            The ultimate shield for your timber. Our Polyurethane range offers unmatched scratch resistance and a non-yellowing film.
          </p>
          <ul class="kamolac-list">
            <li>Matt: Pure, organic elegance.</li>
            <li>Semi-Gloss: The perfect satin balance.</li>
            <li>High-Gloss: A deep, liquid-glass reflection.</li>
          </ul>
          <Link to="/pu-wood-finish" class="kamolac-btn">To know More →</Link>
        </div>
      </div>

     
      <div class="kamolac-card">
         <img src={process.env.PUBLIC_URL + '/images/products/new/1.png'} alt="Kamdhenupaints" /> 
        <div class="kamolac-content">
          <h3>HD-X Masterclass</h3>
          <p class="kamolac-tag">Crystal Clarity</p>
          <p class="kamolac-desc">
            Designed for light-toned woods that demand zero color shift.
          </p>
          <ul class="kamolac-list">
            <li>Feature: Water-white transparency that never turns yellow.</li>
            <li>Sheens: Available in Flat Matt to Mirror High-Gloss.</li>
          </ul>
          <Link to="/hdx-masterclass" class="kamolac-btn">To know More →</Link>
        </div>
      </div>

    
      <div class="kamolac-card">
        <img src={process.env.PUBLIC_URL + '/images/products/new/2.png'} alt="Kamdhenupaints" /> 
        <div class="kamolac-content">
          <h3>Eco-Friendly Water-Based</h3>
          <p class="kamolac-tag">Conscious Luxury</p>
          <p class="kamolac-desc">
            Advanced resin technology with zero harsh odors and low VOCs.
          </p>
          <ul class="kamolac-list">
            <li>Safe for Homes: Ideal for kids’ rooms and occupied spaces.
</li>
            <li>Fast Curing: Multiple coats in a single day.
</li>
          </ul>
          <a href="#range3" class="kamolac-btn">To know More →</a>
        </div>
      </div>

      
      <div class="kamolac-card">
        <img src={process.env.PUBLIC_URL + '/images/products/new/7.png'} alt="Kamdhenupaints" /> 
        <div class="kamolac-content">
          <h3>Metal & Glass Coatings</h3>
          <p class="kamolac-tag">Industrial Edge</p>
          <p class="kamolac-desc">
            Beyond wood—we protect everything.
          </p>
          <ul class="kamolac-list">
            <li>Metal: Anti-corrosive clear and vibrant colour coats for steel and aluminium.
</li>
            <li>Glass: Back-painted colours and "Easy-Clean" hydrophobic protective layers.
</li>
          </ul>
        </div>
      </div>

      
      <div class="kamolac-card">
       <img src={process.env.PUBLIC_URL + '/images/products/new/5.png'} alt="Kamdhenupaints" /> 
        <div class="kamolac-content">
          <h3>Wood Stains</h3>
          <p class="kamolac-tag">Deep Soul</p>
          <p class="kamolac-desc">
           Infuse your wood with character. From classic Teak and Walnut to modern Charcoal and Slate.

          </p>
        </div>
      </div>

    </div>
  </div>
</section>
<section class="kamolac-promise">

  <div class="glass-card">

    <h2 class="promise-title">The Kamolac Promise</h2>

    <div class="quote-box">
      <span class="quote-mark">“</span>

      <p class="promise-text">
        At Kamdhenu Paints, we understand that a finish is more than a layer—
        it’s the final touch of your vision. Kamolac is engineered to ensure
        that vision lasts a lifetime.
      </p>

      <span class="quote-mark right">”</span>
    </div>

  </div>

</section>

<section class="story">

  


  <div class="story-block">
    <div class="text">
      <h2>Why Kamolac?</h2>
      {/* <p class="highlight">Built for India’s toughest conditions.</p> */}

      <div class="points">
        <div>
          <h3>UV Resistance</h3>
          <p>Our coatings stay vibrant under the harsh Indian sun.
</p>
        </div>

        <div>
          <h3>Hardness & Flexibility</h3>
          <p>A film that’s tough enough to resist dents but flexible enough to move with the seasons.
</p>
        </div>

        <div>
          <h3>Expertly Crafted</h3>
          <p>Formulations that have made Kamdhenu a household name in quality.
</p>
        </div>
      </div>
    </div>

    <div class="image"><img src={process.env.PUBLIC_URL + '/images/products/new/1.png'} alt="Kamdhenupaints" /> 
        </div>
  </div>


 
  <div class="story-block reverse">
    <div class="image second"><img src={process.env.PUBLIC_URL + '/images/products/new/5.png'} alt="Kamdhenupaints" /> </div>

    <div class="text">
      <h2>Master the Craft</h2>
      {/* <p class="highlight">We don’t just sell paint—we build experts.</p> */}

      <div class="cta-block">
        <div>
          <h3>Free Applicator Training</h3>
          <p>We don’t just sell paint; we build experts. Our Free Training Center provides hands-on workshops for contractors and painters to master spray techniques and mixing ratios.
</p>
          <a href="#" style={{ marginBottom:10, display: 'block'}}>Register for Free Training</a>
        </div>

        <div>
          <h3>Kirti Nagar Experience Center (New Delhi)</h3>
          <p>Touch, feel, and visualize. Visit our flagship display center in Delhi's furniture heart to see our finishes on full-scale architectural panels.
</p>
          <a href="#">Get Directions to Kirti Nagar</a>
        </div>
      </div>
    </div>
  </div>



</section>


<div><Footer /></div>


    </>
  );
}


export default KamolacCoatingHome;
